<template>
  <footer>
    <div class="wrapper">
      <div class="inner">
        <div class="main">
          <ul class="foot-list">
            <li class="logo">
              <a href="/">
                <img
                  :src="require('images/logo/logo-wh.png')"
                  :alt="t('layouts.footer.logo_banner_alt')"
                />
              </a>
            </li>
            <li class="link-group">
              <ul class="list">
                <li>
                  <a
                    class="link"
                    :href="reeracoenWebsite.url"
                    target="_blank"
                    >{{ reeracoenWebsite.name }}</a
                  >
                </li>
                <li class="phone">
                  <a class="link icon-link" :href="telNoToHref(telNo)"
                    ><FontAwesomeIcon
                      :icon="{ prefix: 'fas', iconName: 'phone-volume' }"
                    ></FontAwesomeIcon
                    >{{ telNo }}</a
                  >
                </li>
                <li class="socials">
                  <span>{{ t('layouts.footer.follow_us') }}</span>
                  <div class="socials-group">
                    <ul class="list">
                      <li class="facebook">
                        <a :href="facebookUrl" target="_blank"
                          ><FontAwesomeIcon
                            :icon="{ prefix: 'fab', iconName: 'facebook-f' }"
                          ></FontAwesomeIcon
                        ></a>
                      </li>
                      <li class="linkedin">
                        <a :href="linkedinUrl" target="_blank"
                          ><FontAwesomeIcon
                            :icon="{ prefix: 'fab', iconName: 'linkedin-in' }"
                          ></FontAwesomeIcon
                        ></a>
                      </li>
                      <li class="line">
                        <a :href="lineUrl" target="_blank"
                          ><FontAwesomeIcon
                            :icon="{ prefix: 'fab', iconName: 'line' }"
                          ></FontAwesomeIcon
                        ></a>
                      </li>
                      <li class="youtube">
                        <a :href="youtubeUrl" target="_blank"
                          ><FontAwesomeIcon
                            :icon="{ prefix: 'fab', iconName: 'youtube' }"
                          ></FontAwesomeIcon
                        ></a>
                      </li>
                      <li class="mail">
                        <a :href="'mailto:' + mailAddress"
                          ><FontAwesomeIcon
                            :icon="{ prefix: 'fas', iconName: 'envelope' }"
                          ></FontAwesomeIcon
                        ></a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </li>
            <li class="copyright">
              <p>Copyright © 2021 Reeracoen. All rights reserved.</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// I18n
import I18n from 'i18n/i18n'
import 'i18n/views/layouts/en'
import 'i18n/views/layouts/th'
import 'i18n/views/layouts/ja'
import { i18n } from 'mixins/i18n'
window.I18n = I18n

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFacebookF,
  faLinkedinIn,
  faLine,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPhoneVolume } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFacebookF)
library.add(faLinkedinIn)
library.add(faLine)
library.add(faYoutube)
library.add(faEnvelope)
library.add(faPhoneVolume)

import settings from 'consts/settings.js.erb'
import helpers from 'mixins/helpers'

export default {
  components: {
    FontAwesomeIcon,
  },

  mixins: [i18n, helpers],

  data() {
    return {
      reeracoenWebsite: {
        name: 'Reeracoen Thailand',
        url: settings.social_url.reeracoen,
      },
      facebookUrl: settings.social_url.facebook,
      linkedinUrl: settings.social_url.linkedin,
      lineUrl: settings.social_url.line,
      youtubeUrl: settings.social_url.youtube,
      mailAddress: settings.contact.email,
      telNo: settings.contact.tel,
    }
  },
}
</script>

<style lang="scss" scoped>
@import 'stylesheets/global';

footer {
  background: linear-gradient(180deg, #3742fa 0%, #000ce2 100%);
  padding: 2rem 0;
  width: 100%;

  .foot-list {
    align-items: center;
    display: flex;
    flex-direction: column;

    li {
      margin-bottom: 3rem;

      @include sp {
        margin-bottom: 1.5rem;
      }
    }

    .logo {
      img {
        opacity: 0.8;
        width: 200px;

        @include sp {
          width: 150px;
        }
      }
    }

    .link-group {
      width: 100%;

      .list {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;

        @include sp {
          align-items: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        li {
          margin-bottom: 0;

          @include sp {
            margin-bottom: 1rem;
          }
        }

        .link {
          color: $white;
          font-size: 1em;
          font-weight: 500;
          opacity: 0.8;

          &:hover,
          &:focus {
            opacity: 1;
          }
        }

        .icon-link {
          align-items: center;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .phone {
          .fa-phone-volume {
            font-size: 20px;
            margin-right: 8px;
            transform: rotate(-45deg);
          }
        }

        .socials {
          align-items: center;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;

          span {
            color: $white;
            font-size: 1em;
            font-weight: 500;
            margin-right: 10px;
            opacity: 0.8;
          }

          .socials-group {
            .list {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;

              li {
                margin-bottom: 0;
              }

              a {
                color: $white;
                font-size: 1em;
                margin-right: 12px;
                opacity: 0.8;

                &:hover,
                &:focus {
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }

    .copyright {
      color: $white;
      font-size: 0.85rem;
      letter-spacing: 1px;
      margin-bottom: 0;
      margin-top: 2rem;
      opacity: 0.65;
      text-align: center;

      @include sp {
        font-size: 10px;
        margin-bottom: 0;
        margin-top: 0;
      }
    }
  }
}
</style>
